<div class="form-modal" *ngIf="detailForm">
  <h1 mat-dialog-title>{{'LINE_DETAILS'|translate}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="detailForm" class="form-horizontal">
      <div class="form-group">

        <!-- Panel base -->
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup1"
              (click)="collPnPopup1 = !collPnPopup1">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'BASE' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup1, 'fa-caret-up': !collPnPopup1}"></i>
              </h5>
            </div>
            <div id="collPnPopup1" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Número linha -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'LINE_NUMBER' | translate}}</mat-label>
                    <input matInput formControlName="LineNumber">
                  </mat-form-field>
                  <span *ngIf="formErrors.LineNumber" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.LineNumber">{{ formErrors.LineNumber }}</span>
                </div>
                <!-- Código cliente -->
                <div class="col-md-3 col-sm-12" *ngIf="!hideCodeClient">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'CLIENT_CODE' | translate}}</mat-label>
                    <input matInput formControlName="BuyerProductCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.BuyerProductCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BuyerProductCode">{{ formErrors.BuyerProductCode }}</span>
                </div>
                <!-- Código Fornecedor -->
                <div class="col-md-3 col-sm-12" *ngIf="!hideCodeSupplier">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'SELLER_CODE' | translate}}</mat-label>
                    <input matInput formControlName="SupplierProductCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.SupplierProductCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.SupplierProductCode">{{ formErrors.SupplierProductCode }}</span>
                </div>
                <!-- Código EAN -->
                <div class="col-md-4 col-sm-12" *ngIf="!hideEanCode">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'EANCODE' | translate}}</mat-label>
                    <input matInput formControlName="StandardProductCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.StandardProductCode" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.StandardProductCode">{{ formErrors.StandardProductCode }}</span>
                </div>
                <div *ngIf="showCostCenterDetail" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'COST_CENTER' | translate}}</mat-label>
                    <input matInput
                      formControlName="CostCenterName" class="one" readonly>
                      <i matSuffix *ngIf="!formDisabled" class="glyphicon glyphicon-new-window link" (click)="selectCostCenterDetail()"></i>
                  </mat-form-field>
                  <span *ngIf="formErrors.CostCenterID" class="field-validation-valid text-danger"
                    [translate] [translateParams]="formErrorsParam.CostCenterID">{{
                    formErrors.CostCenterID }}</span>
                </div>

                <div
                  *ngIf="(!formErrors.ProductDescription || detailForm.controls.ProductDescription.valid) && (!formErrors.BuyerProductCode || detailForm.controls.BuyerProductCode.valid)"
                  class="col-md-12 col-sm-12 spacer-bottom-xs"></div>
                <!-- Descrição -->
                <div class="col-md-5 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'DESCRIPTION' | translate}}</mat-label>
                    <ng-container *ngIf="showDescriptionAsTextArea">
                    <textarea matInput formControlName="ProductDescription">
                    </textarea>
                  </ng-container>
                  <ng-container *ngIf="!showDescriptionAsTextArea">
                    <input matInput formControlName="ProductDescription">
                  </ng-container>
                    </mat-form-field>
                  <span *ngIf="formErrors.ProductDescription" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ProductDescription">{{ formErrors.ProductDescription }}</span>
                </div>
                <!-- Data de Remessa -->
                <div class="col-md-3 col-sm-12" *ngIf="showShippingDate">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'SHIPPING_ORDER_DATE' | translate}}</mat-label>
                    <input matInput formControlName="ShippingDate">
                  </mat-form-field>
                </div>
                <!-- Data entrega -->
                <div *ngIf="showDeliveryDateOnBasePanel && !isServiceProvider" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'EARLIEST_ACCEPTABLE_DATE' | translate}}</mat-label>

                    <input *ngIf="!useDeliveryDateSchedule" matInput
                      formControlName="DeliveryEarliestAcceptableDate" class="one date-picker" [tipoDateTime]="3"
                      [stepMinutes]="1">

                    <input *ngIf="useDeliveryDateSchedule" matInput
                      formControlName="DeliveryEarliestAcceptableDate" class="one date-picker" [tipoDateTime]="3"
                      id="datePickerScheduleDetail" [minDays]="minDays" [minHour]="minHour" [maxHour]="maxHour"
                      [weekDays]="weekDays" [orderHourLimit]="orderHourLimit">

                      <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                  </mat-form-field>
                  <error [control]="detailForm.get('DeliveryEarliestAcceptableDate')"></error>
                  <span *ngIf="formErrors.DeliveryEarliestAcceptableDate" class="field-validation-valid text-danger"
                    [translate] [translateParams]="formErrorsParam.DeliveryEarliestAcceptableDate">{{
                    formErrors.DeliveryEarliestAcceptableDate }}</span>
                </div>
                <!-- Código contabilístico -->
                <div class="col-md-3 col-sm-12" *ngIf="showAccountingCode">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'ACCOUTING_CODE' | translate}}</mat-label>
                    <input matInput formControlName="AccountingCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.AccountingCode" class="field-validation-valid text-danger" [translate]
                  [translateParams]="formErrorsParam.AccountingCode">{{ formErrors.AccountingCode }}</span>
                </div>

                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Familia -->
                <div *ngIf="showFamily" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'FAMILY' | translate}}</mat-label>
                    <mat-select formControlName="FamilyLv1"
                      (selectionChange)="onChangeFamilyLv1($event)">
                      <mat-select-header class="device-select-header">
                        <mat-form-field class="col-sm-12 md-select-search">
                          <mat-label>{{'SEARCH'|translate}}</mat-label>
                          <input matInput #searchFamilyLv1 type="text">
                          <i matSuffix class="fas fa-search"></i>
                        </mat-form-field>
                      </mat-select-header>
                      <mat-option></mat-option>
                      <mat-option
                        *ngFor="let family1 of familiesLv1 | mdSelectContainsPipe:['Name', searchFamilyLv1.value]"
                        [value]="family1.ID">{{family1.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="showFamily && familiesLv2 && familiesLv2.length > 0" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-select formControlName="FamilyLv2" (selectionChange)="onChangeFamilyLv2($event)">
                      <mat-select-header class="device-select-header">
                        <mat-form-field class="col-sm-12 md-select-search">
                          <mat-label>{{'SEARCH'|translate}}</mat-label>
                          <input matInput #searchFamilyLv2 type="text">
                          <i matSuffix class="fas fa-search"></i>
                        </mat-form-field>
                      </mat-select-header>
                      <mat-option></mat-option>
                      <mat-option
                        *ngFor="let family2 of familiesLv2 | mdSelectContainsPipe:['Name', searchFamilyLv2.value]"
                        [value]="family2.ID">{{family2.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="showFamily && familiesLv3 && familiesLv3.length > 0" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-select formControlName="FamilyLv3">
                      <mat-select-header class="device-select-header">
                        <mat-form-field class="col-sm-12 md-select-search">
                          <mat-label>{{'SEARCH'|translate}}</mat-label>
                          <input matInput #searchFamilyLv3 type="text">
                          <i matSuffix class="fas fa-search"></i>
                        </mat-form-field>
                      </mat-select-header>
                      <mat-option></mat-option>
                      <mat-option
                        *ngFor="let family3 of familiesLv3 | mdSelectContainsPipe:['Name', searchFamilyLv3.value]"
                        [value]="family3.ID">{{family3.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="showProductServiceTypeFields">
                  <div class="col-md-3 col-sm-12">
                    <mat-form-field class="allwidth">
                      <mat-label>{{ 'PRODUCT_SERVICE_TYPE' | translate}}</mat-label>
                      <input matInput formControlName="AccountProductTypeDescription" class="one" readonly>
                        <i matSuffix class="glyphicon glyphicon-new-window" (click)="setAccountProductType()"></i>
                    </mat-form-field>
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <mat-form-field class="allwidth">
                      <mat-label>{{ 'VAT_TREATMENT_TYPE' | translate}}</mat-label>
                      <mat-select formControlName="VatTreatmentType"
                        (selectionChange)="onChangeVatTreatmentType($event)">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let prod of vatTreatmentTypes" [value]="prod.ItemCode">{{prod.ItemName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <mat-form-field class="allwidth">
                      <mat-label>{{ 'PRODUCT_SERVICE_SUBTYPE' | translate}}</mat-label>
                      <input matInput formControlName="AccountProductSubtypeDescription" [ngClass]="'one'" readonly>
                        <i matSuffix class="glyphicon glyphicon-new-window" (click)="setAccountProductSubtype()"></i>
                    </mat-form-field>
                  </div>
                </div>
                
                <!-- Código Centro Custo -->
                <div *ngIf="useProductCostCenter && !hideCostCenter" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth" *ngIf="!formDisabled && context == 'encomendaCompra'">
                    <mat-label>{{ 'COST_CENTER' | translate}}</mat-label>
                    <input matInput
                      readonly="true"
                      formControlName="CostCenterDescription"
                      class="one">
                      <i matSuffix class="glyphicon glyphicon-new-window" (click)="selectExternalCostCenter()"></i>
                  </mat-form-field>
                  <div *ngIf="formDisabled && context == 'encomendaCompra'">
                    <dropdown-selector-modal formControlName="CostCenter"
                      [dropdownTitle]="'COST_CENTERS_LIST'|translate"
                      [DropDownID]="'CostCenter'" [editMode]="false"
                      [placeHolder]="'COST_CENTER'| translate">
                    </dropdown-selector-modal>
                    <span *ngIf="formErrors.CostCenter" class="field-validation-valid text-danger" [translate]
                      [translateParams]="formErrorsParam.CostCenter">{{formErrors.CostCenter}}</span>
                  </div>
                </div>

                
                
                <!-- Código Reclassificação -->
                <div *ngIf="useProductReclassificationCode" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth" *ngIf="!formDisabled && context == 'encomendaCompra'">
                    <mat-label>{{ 'RECLASSIFICATION_CODE' | translate}}</mat-label>
                    <input matInput
                      readonly="true"
                      formControlName="ReclassificationDescription"
                      class="one">
                      <i matSuffix class="glyphicon glyphicon-new-window" (click)="selectRecCode()"></i>
                  </mat-form-field>
                  <div *ngIf="formDisabled && context == 'encomendaCompra'">
                    <dropdown-selector-modal formControlName="ReclassificationCode"
                      [dropdownTitle]="'SELECT_RECLASSIFICATION_CODE'|translate"
                      [DropDownID]="'ReclassificationCode'" [editMode]="false"
                      [placeHolder]="'RECLASSIFICATION_CODE'| translate">
                    </dropdown-selector-modal>
                    <span *ngIf="formErrors.ReclassificationCode" class="field-validation-valid text-danger" [translate]
                      [translateParams]="formErrorsParam.ReclassificationCode">{{formErrors.ReclassificationCode}}</span>
                  </div>
                </div>
                
                <!-- Processo -->
                <div *ngIf="orderService.showProcess && detailForm.controls.Process && (documentType == 'PropertiesOrder' || documentType == 'NCPropOrder')" class="col-md-3 col-sm-12">
                  <dropdown-selector-modal formControlName="Process"
                    [dropdownTitle]="'PROCESS'|translate"
                    [DropDownID]="'PropertyProcess'" [editMode]="!formDisabled"
                    [placeHolder]="'PROCESS'| translate"
                    [dropdownList]="processDropdown"
                    (onChangeDropdown)="onChangeProcess($event)">
                  </dropdown-selector-modal>
                  <error [control]="detailForm.get('Process')"></error>
                </div>


                <!-- Fração -->
                <div *ngIf="fractionDropdown?.length > 0 && orderService.showFraction && detailForm.controls.Fraction && (documentType == 'PropertiesOrder' || documentType == 'NCPropOrder')" class="col-md-3 col-sm-12">
                  <dropdown-selector-modal formControlName="Fraction"
                    [dropdownTitle]="'FRACTION'|translate"
                    [DropDownID]="'PropertyFraction'" [editMode]="!formDisabled"
                    [placeHolder]="'FRACTION'| translate"
                    [dropdownList]="fractionDropdown">
                  </dropdown-selector-modal>
                </div>

                <!-- Numero de documento da requisição de onde este detalhe foi criado -->
                <div *ngIf="detailForm.get('RequestDocumentNumber') && detailForm.get('RequestDocumentNumber').value" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'REQUEST_DOCUMENT_NUMBER' | translate}}</mat-label>
                    <input matInput
                      formControlName="RequestDocumentNumber"
                      class="one">
                  </mat-form-field>
                </div>

                <!-- Numero da linha da requisição de onde este detalhe foi criado -->
                <div *ngIf="detailForm.get('RequestLineNumber') && detailForm.get('RequestLineNumber').value" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'REQUEST_LINE_NUMBER' | translate}}</mat-label>
                    <input matInput
                      formControlName="RequestLineNumber"
                      class="one">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel quantidades -->
        <div class="col-sm-12">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup2"
              (click)="collPnPopup2 = !collPnPopup2">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'QUANTITIES' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup2, 'fa-caret-up': !collPnPopup2}"></i>
              </h5>
            </div>
            <div id="collPnPopup2" class="panel-body no-horizontal-padding collapse in">

              <div class="form-group">
                <!-- Quantidade encomendada -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ (context == 'requisicao' ? 'REQUESTED_QUANTITY' : 'ORDERED_QUANTITY') | translate}}</mat-label>
                    <input matInput format
                      formControlName="OrderedQuantity" (input)="calculateDetailValues()"
                      (change)="checkQuantityIncrement()">
                    <!-- <mat-icon *ngIf="productQuantityValidations && detailForm.get('OrderedQuantity').enabled"
                      class="one link">
                      <i class="fas fa-arrow-up" (click)="increaseOrderedQtd()"></i>
                      <i class="fas fa-arrow-down" (click)="reduceOrderedQtd()"></i>
                    </mat-icon> -->

                    <i matSuffix *ngIf="showQuantityArrows && detailForm.get('OrderedQuantity').enabled"
                      class="fas fa-arrow-up pointer" (click)="increaseOrderedQtd()"></i>
                    <i matSuffix *ngIf="showQuantityArrows && detailForm.get('OrderedQuantity').enabled"
                      class="fas fa-arrow-down pointer" (click)="reduceOrderedQtd()"></i>

                  </mat-form-field>
                  <span *ngIf="formErrors.OrderedQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.OrderedQuantity">{{ formErrors.OrderedQuantity }}</span>
                </div>
                <!-- Unidade -->
                <div *ngIf="showOrderedQuantityUOMCode" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'UNITY_MEASURE' | translate}}</mat-label>
                    <mat-select formControlName="OrderedQuantityUOMCode" (selectionChange)="onChangeUOMCode($event)">
                      <mat-option value=''></mat-option>
                      <mat-option *ngFor="let unit of detailUnitsG" [value]="unit.Code">{{unit.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- Unit -->
                <div
                  *ngIf="showOrderedQuantityUOMCode && detailForm && detailForm.get('OrderedQuantityUOMCode').value === 'Other'"
                  class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'OTHER_UNIT' | translate}}</mat-label>
                    <input matInput
                      formControlName="OrderedQuantityUOMCodeOther">
                  </mat-form-field>
                </div>

                <!-- Quantidade Gratis -->
                <div class="col-md-2 col-sm-12" *ngIf="showBonusQuantity">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'FREE_QTT' | translate}}</mat-label>
                    <input matInput formControlName="BonusQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.BonusQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.BonusQuantity">{{ formErrors.BonusQuantity }}</span>
                </div>
                <!-- Unidade -->
                <div *ngIf="showBonusQuantityUOM" class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'UNITY_MEASURE' | translate}}</mat-label>
                    <mat-select formControlName="BonusQuantityUOMCode">
                      <mat-option *ngFor="let unit of detailUnitsG" [value]="unit.Code">{{unit.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="formErrors.BonusQuantityUOM"
                    class="field-validation-valid text-danger">{{formErrors.BonusQuantityUOM}}</span>
                </div>

                <!-- Unidade de preço -->
                <div class="col-md-3 col-sm-12" *ngIf="showPriceUnit">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'PRICE_UNIT' | translate}}</mat-label>
                    <input matInput formControlName="PriceUnit">
                  </mat-form-field>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Panel preços -->
        <div class="col-sm-12" *ngIf="showTotalNetAmount || (orderService.OrderDetailPurchaseSettings.showPanelPrices && context === 'encomendaCompra') || (orderService.OrderDetailSaleSettings.showPanelPrices && context === 'encomendaVenda') ">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup3"
              (click)="collPnPopup3 = !collPnPopup3">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'PRICES' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup3, 'fa-caret-up': !collPnPopup3}"></i>
              </h5>
            </div>
            <div id="collPnPopup3" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">

                <!-- Preço Unit Bruto -->
                <div *ngIf="showGrossUnitPrice" class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'GROSS_UNIT_PRICE' | translate}}</mat-label>
                    <input format matInput class="text-right one"
                      formControlName="GrossUnitPrice" (focusout)="calculateDetailValues()">
                  </mat-form-field>
                  <span *ngIf="formErrors.GrossUnitPrice" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.GrossUnitPrice">{{formErrors.GrossUnitPrice}}</span>
                </div>

                <!-- Total Bruto -->
                <div *ngIf="showTotalGrossAmount" class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'GROSS_TOTAL' | translate}}</mat-label>
                    <input format matInput class="text-right one"
                      formControlName="TotalGrossAmount" (focusout)="onChangeTotalGrossAmount()">
                  </mat-form-field>
                  <span *ngIf="formErrors.TotalGrossAmount" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.TotalGrossAmount">{{ formErrors.TotalGrossAmount }}</span>
                </div>

                <!-- Preço Unit Liquido -->
                <div *ngIf="showNetUnitPrice" class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ netUnitPriceLabel | translate}}</mat-label>
                    <input format matInput class="text-right one"
                      formControlName="NetUnitPrice" (focusout)="onChangeNetUnitPrice()">
                  </mat-form-field>
                  <span *ngIf="formErrors.NetUnitPrice" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.NetUnitPrice">{{ formErrors.NetUnitPrice }}</span>
                </div>

                <!-- Total Liquido -->
                <div *ngIf="showTotalNetAmountDetail" class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ (context === 'encomendaCompra' ? orderService.OrderDetailPurchaseSettings.totalNetAmountLabel  : orderService.OrderDetailSaleSettings.totalNetAmountLabel) | translate}}</mat-label>
                    <input format matInput class="text-right one" 
                      formControlName="TotalNetAmount" (focusout)="onChangeTotalNetAmount()">
                  </mat-form-field>
                  <span *ngIf="formErrors.TotalNetAmount" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.TotalNetAmount">{{ formErrors.TotalNetAmount }}</span>
                </div>

                <div *ngIf="showDistributionDetails || showCostCenterDistributionDetails" class="col-md-2 col-sm-12">
                  <button type="button" class="btn btn-primary no-margin-left" (click)="showDistributionDetails ? openDistribution() : openCostCenterDistribution()">
                    {{ distributionButtonLabel | translate}}&nbsp;
                    <i *ngIf="hasDistribution" class="fas fa-check"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel embalagens -->
        <div class="col-sm-12" *ngIf="showPackagingPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup4"
              (click)="collPnPopup4 = !collPnPopup4">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'PACKAGES' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup4, 'fa-caret-up': !collPnPopup4}"></i>
              </h5>
            </div>
            <div id="collPnPopup4" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- qtdEmbalagens -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'PACKAGES_QUANTITY' | translate}}</mat-label>
                    <input matInput formControlName="PackQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackQuantity">{{ formErrors.PackQuantity }}</span>
                </div>
                <!-- Unidade -->
                <div class="col-md-3 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'UNIT' | translate}}</mat-label>
                    <mat-select formControlName="PackQuantityUOM">
                      <mat-option *ngFor="let unit of detailUnitsG" [value]="unit.Code">{{unit.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <!-- qtdPorEmbalagens -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'QUANTITY_FOR_PACKAGES' | translate}}</mat-label>
                    <input matInput formControlName="PackSize">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackSize" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackSize">{{ formErrors.PackSize }}</span>
                </div>
                <!-- Embalagens por camada -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'PACK_UNITS_PER_LAYER' | translate}}</mat-label>
                    <input matInput
                      formControlName="PackUnitsPerLayer">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackUnitsPerLayer" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackUnitsPerLayer">{{ formErrors.PackUnitsPerLayer }}</span>
                </div>
                <!-- Peso médio -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'MEDIUM_WEIGHT' | translate}}</mat-label>
                    <input matInput
                      formControlName="PackAverageGrossWeight">
                  </mat-form-field>
                  <span *ngIf="formErrors.PackAverageGrossWeight" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.PackAverageGrossWeight">{{ formErrors.PackAverageGrossWeight
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel local de entrega -->
        <div class="col-sm-12" *ngIf="showDeliveryPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup5"
              (click)="collPnPopup5 = !collPnPopup5">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'DELIVERY' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup5, 'fa-caret-up': !collPnPopup5}"></i>
              </h5>
            </div>
            <div id="collPnPopup5" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Código entrega-->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'CODE' | translate}}</mat-label>
                    <input matInput formControlName="DeliveryLocationIdentifier"
                      class="one">
                      <i *ngIf="!formDisabled" matSuffix class="glyphicon glyphicon-new-window" (click)="selectLocalDeliveryDetails()"></i>
                  </mat-form-field>
                  <span *ngIf="formErrors.DeliveryLocationIdentifier" class="field-validation-valid text-danger"
                    [translate] [translateParams]="formErrorsParam.DeliveryLocationIdentifier">{{
                    formErrors.DeliveryLocationIdentifier }}</span>
                </div>
                <!-- Nome entrega -->
                <div class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'NAME' | translate}}</mat-label>
                    <input matInput formControlName="DeliveryLocationName">
                  </mat-form-field>
                  <span *ngIf="formErrors.DeliveryLocationName" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.DeliveryLocationName">{{ formErrors.DeliveryLocationName
                    }}</span>
                </div>
                <!-- Morada entrega -->
                <div class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'ADDRESS' | translate}}</mat-label>
                    <input matInput formControlName="DeliveryLocationStreet">
                  </mat-form-field>
                  <span *ngIf="formErrors.DeliveryLocationStreet" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.DeliveryLocationStreet">{{ formErrors.DeliveryLocationStreet
                    }}</span>
                </div>
                <!-- Codigo postal entrega -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'POSTAL_CODE' | translate}}</mat-label>
                    <input matInput
                      formControlName="DeliveryLocationPostalCode">
                  </mat-form-field>
                  <span *ngIf="formErrors.DeliveryLocationPostalCode" class="field-validation-valid text-danger"
                    [translate] [translateParams]="formErrorsParam.DeliveryLocationIdentifier">{{
                    formErrors.DeliveryLocationPostalCode }}</span>
                </div>
                <div class="col-md-12 spacer-bottom-xs"></div>
                <!-- Cidade entrega -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'CITY' | translate}}</mat-label>
                    <input matInput formControlName="DeliveryLocationCity">
                  </mat-form-field>
                  <span *ngIf="formErrors.DeliveryLocationCity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.DeliveryLocationCity">{{ formErrors.DeliveryLocationCity
                    }}</span>
                </div>
                 <!-- País entrega -->
                 <div class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'COUNTRY' | translate}}</mat-label>
                    <mat-select formControlName="DeliveryLocationCountryCode">
                      <mat-option *ngFor="let country of allCountries" [value]="country.Code">{{country.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                
                
                <!-- Espaço -->
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
               <!-- Pedido por -->
               <div class="col-md-2 col-sm-12">
                <mat-form-field class="allwidth">
                  <mat-label>{{ 'ORDEREDBY' | translate}}</mat-label>
                  <input matInput formControlName="OrderedBy">
                </mat-form-field>
                <span *ngIf="formErrors.OrderedBy" class="field-validation-valid text-danger">{{ formErrors.OrderedBy
                  }}</span>
              </div>
                <!-- Data entrega -->
                <div class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'EARLIEST_ACCEPTABLE_DATE' | translate}}</mat-label>

                    <input *ngIf="!useDeliveryDateSchedule" matInput
                      formControlName="DeliveryEarliestAcceptableDate" class="one date-picker" [tipoDateTime]="defaultDateTimeFormatDeliveryDate"
                      [stepMinutes]="1">

                    <input *ngIf="useDeliveryDateSchedule" matInput
                      formControlName="DeliveryEarliestAcceptableDate" class="one date-picker" [tipoDateTime]="3"
                      [stepMinutes]="1" id="datePickerScheduleDetail" [minDays]="minDays" [minHour]="minHour"
                      [maxHour]="maxHour" [weekDays]="weekDays" [orderHourLimit]="orderHourLimit">

                      <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                  </mat-form-field>
                  <error [control]="detailForm.get('DeliveryEarliestAcceptableDate')"></error>
                  <span *ngIf="formErrors.DeliveryEarliestAcceptableDate" class="field-validation-valid text-danger"
                    [translate] [translateParams]="formErrorsParam.DeliveryEarliestAcceptableDate">{{
                    formErrors.DeliveryEarliestAcceptableDate }}</span>
                </div>
                <!-- Data limite de entrega -->
                <div *ngIf="showLatestAcceptableDate && detailForm?.get('DeliveryLatestAcceptableDate')?.value" class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'LATEST_ACCEPTABLE_DATE' | translate}}</mat-label>
                    <input matInput
                      formControlName="DeliveryLatestAcceptableDate" class="one date-picker" [tipoDateTime]="3">
                      <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                  </mat-form-field>
                  <span *ngIf="formErrors.DeliveryLatestAcceptableDate" class="field-validation-valid text-danger"
                    [translate] [translateParams]="formErrorsParam.DeliveryLatestAcceptableDate">{{
                    formErrors.DeliveryLatestAcceptableDate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel taxas -->
        <div class="col-sm-6" *ngIf="showTaxesPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup6"
              (click)="collPnPopup6 = !collPnPopup6">
              <h5 class="panel-title">
                <i class="fas fa-percentage"></i>
                <strong>{{ 'RATES' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup6, 'fa-caret-up': !collPnPopup6}"></i>
              </h5>
            </div>
            <div id="collPnPopup6" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">                
                <div class="col-md-4 col-sm-12" *ngIf="!disableTaxes && !formDisabled">
                  <button type="button" class="btn btn-primary no-margin-left" title="{{'LINE' | translate}}"
                    *ngIf="allowEdit" (click)="addTax(true)">
                    <i class="fas fa-plus"></i>&nbsp;{{'ADD' | translate}}
                  </button>
                </div>

                <ng-container *ngIf="showAccountingVat">
                  <div class="col-md-4 col-sm-12">
                    <mat-form-field class="allwidth">
                      <mat-label>{{ 'VAT_CODE' | translate}}</mat-label>
                      <mat-select formControlName="AccountingVATID"
                      (selectionChange)="onChangeAccountingVat($event)">
                        <mat-option></mat-option>
                          <mat-option *ngFor="let accountingVAT of accountingVATs" [value]="accountingVAT.ID">
                            {{accountingVAT.Description}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <span *ngIf="formErrors.AccountingVATID" class="field-validation-valid text-danger" [translate]
                      [translateParams]="formErrorsParam.AccountingVATID">{{
                      formErrors.AccountingVATID }}</span>
                  </div>
                </ng-container>

                <div *ngIf="(showVatExemptReason && exemptReasonVisible)" class="col-md-4 col-sm-12">
                  <!-- motivo de isencao -->
                  <mat-form-field class="allwidth">
                    <mat-label>{{'REASON_FOR_EXEMPTION'|translate}}</mat-label>
                    <mat-select formControlName="VatExemptReasonID"
                      [ngClass]="{ 'mat-input-invalid': !detailForm.controls.VatExemptReasonID.valid}">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let item of valueAddedTaxExemptReasons" [value]="item.IntegrationID"  [matTooltip]="item.Norm"
                      [matTooltipPosition]="'after'">
                        {{item.IntegrationID + ' - ' + item.Norm}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="formErrors.VatExemptReasonID" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.VatExemptReasonID">{{
                    formErrors.VatExemptReasonID }}</span>
                </div>

                <div *ngIf="detailForm.controls.Taxes.length>0" class="table-responsive col-md-12 col-sm-12">
                  <div *ngIf="formErrorsTaxes.length>0" class="validation-summary-errors text-danger col-md-6">
                    <ul>
                      <li *ngFor="let errorMessage of formErrorsTaxes; let i = index" [translate]
                        [translateParams]="formErrorsTaxesParam[i]">{{errorMessage}}</li>
                    </ul>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th class="text-center" width="33%">{{ 'TYPE' | translate}}</th>
                        <th class="text-center" width="33%">{{ 'PERCENTAGE' | translate}}</th>
                        <th class="text-center" [width]="'33%'">{{ 'VALUE' | translate}}</th>
                        <th width="1%" *ngIf="!disableTaxes && !formDisabled"></th>
                      </tr>
                    </thead>
                    <tbody formArrayName="Taxes">
                      <tr *ngFor="let tax of detailForm.controls.Taxes.controls; let i=index" [formGroupName]="i">
                        <td>
                          <div *ngIf="tax.get('TaxTypeCode').value !== 'Other' || (tax.get('TaxTypeCode').value === 'Other' && !showTaxTypeCodeOther)">
                            <mat-form-field class="allwidth">
                              <mat-select formControlName="TaxTypeCode" (selectionChange)="calculateDetailValues()">
                                <mat-option value=''></mat-option>
                                <mat-option *ngFor="let item of detailTaxes" [value]="item.ID">{{item.Name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div *ngIf="tax.get('TaxTypeCode').value === 'Other' && showTaxTypeCodeOther" class="col-md-6 col-sm-6">
                            <mat-form-field class="allwidth">
                              <mat-select formControlName="TaxTypeCode" (selectionChange)="calculateDetailValues()">
                                <mat-option value=''></mat-option>
                                <mat-option *ngFor="let item of detailTaxes" [value]="item.ID">{{item.Name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div *ngIf="tax.get('TaxTypeCode').value === 'Other' && showTaxTypeCodeOther" class="col-md-6 col-sm-6">
                            <mat-form-field class="allwidth" (selectionChange)="calculateDetailValues()">
                              <input matInput formControlName="TaxTypeCodeOther">
                            </mat-form-field>
                          </div>
                        </td>
                        <td>
                          <mat-form-field
                            *ngIf="tax.get('TaxTypeCode').value !== 'ValueAddedTax'"
                            class="allwidth">
                            <input format matInput formControlName="TaxRate" class="text-right one" 
                              (focusout)="calculateDetailValues()">
                            <i matSuffix class="one">%</i>
                          </mat-form-field>
                          <mat-form-field
                            *ngIf="tax.get('TaxTypeCode').value === 'ValueAddedTax'"
                            class="allwidth">
                            <mat-select formControlName="TaxRate" (selectionChange)="checkVatExemptVisible();calculateDetailValues()">
                              <mat-option></mat-option>
                              <mat-option *ngFor="let item of valueAddedTaxes" [value]="item.TaxPercentage">
                                {{item.TaxPercentage}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field class="allwidth">
                            <input format matInput class="text-right one" formControlName="TaxAmount">
                          </mat-form-field>
                        </td>
                        <td class="text-right" *ngIf="!disableTaxes && !formDisabled">
                          <button type="button" class="btn btn-sm" (click)="removeTaxe(i);checkVatExemptVisible()" *ngIf="tax.get('TaxTypeCode').enabled">
                            <span title="{{'BUTTON.DELETE' | translate}}">
                              <i class="far fa-trash-alt color-danger backwhite"></i>
                            </span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel abonos -->
        <div class="col-sm-12" *ngIf="showAllowancesPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup7"
              (click)="collPnPopup7 = !collPnPopup7">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'ALLOWANCES' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup7, 'fa-caret-up': !collPnPopup7}"></i>
              </h5>
            </div>
            <div id="collPnPopup7" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">

                <div class="col-md-12 col-sm-12">
                  <button type="button" class="btn btn-primary no-margin-left" title="{{'LINE' | translate}}"
                    *ngIf="allowEdit" (click)="addAllowance(true)">
                    <i class="fas fa-plus"></i>&nbsp;{{'ADD' | translate}}
                  </button>
                </div>

                <div *ngIf="detailForm.controls.Allowances.length>0" class="table-responsive col-md-12 col-sm-12">
                  <div *ngIf="formErrorsAllowance.length>0" class="validation-summary-errors text-danger col-md-6">
                    <ul>
                      <li *ngFor="let errorMessage of formErrorsAllowance; let i = index" [translate]
                        [translateParams]="formErrorsAllowanceParam[i]">{{errorMessage}}</li>
                    </ul>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th class="text-center">{{ 'TYPE' | translate}}</th>
                        <th class="text-center">{{ 'PERCENTAGE' | translate}}</th>
                        <th class="text-center">{{ 'AMOUNT' | translate}}</th>
                        <th *ngIf="allowEdit"></th>
                      </tr>
                    </thead>
                    <tbody formArrayName="Allowances">
                      <tr *ngFor="let item of detailForm.controls.Allowances.controls; let i=index" [formGroupName]="i">
                        <td>
                          <mat-form-field class="allwidth">
                            <input matInput formControlName='AllowanceType'>
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field class="allwidth">
                            <input matInput formControlName='Percentage' class="text-right one">
                            <i matSuffix class="one">%</i>
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field class="allwidth">
                            <input matInput formControlName='Amount' class="text-right">
                          </mat-form-field>
                        </td>
                        <td class="text-right" *ngIf="allowEdit">
                          <button type="button" class="btn btn-sm" (click)="removeAllowance(i)">
                            <span title="{{'BUTTON.DELETE' | translate}}">
                              <i class="far fa-trash-alt color-danger backwhite"></i>
                            </span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel descontos -->
        <div class="col-sm-6" *ngIf="showDiscountsPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup8"
              (click)="collPnPopup8 = !collPnPopup8">
              <h5 class="panel-title">
                <i class="fas fa-percentage"></i>
                <strong>{{ 'DISCOUNTS' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup8, 'fa-caret-up': !collPnPopup8}"></i>
              </h5>
            </div>
            <div id="collPnPopup8" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">

                <div class="col-md-12 col-sm-12">
                  <button type="button" class="btn btn-primary no-margin-left" title="{{'LINE' | translate}}"
                    *ngIf="allowEdit && detailForm.get('Discounts').enabled" (click)="addDiscount(true)">
                    <i class="fas fa-plus"></i>&nbsp;{{'ADD' | translate}}
                  </button>
                </div>

                <div *ngIf="detailForm.controls.Discounts.length>0" class="table-responsive col-md-12 col-sm-12">
                  <div *ngIf="formErrorsDiscount.length>0" class="validation-summary-errors text-danger col-md-6">
                    <ul>
                      <li *ngFor="let errorMessage of formErrorsDiscount; let i = index" [translate]
                        [translateParams]="formErrorsDiscountParam[i]">{{errorMessage}}</li>
                    </ul>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th class="text-center" width="33%">{{ 'TYPE' | translate}}</th>
                        <th class="text-center" width="33%">{{ 'PERCENTAGE' | translate}}</th>
                        <th class="text-center" width="33%">{{ 'VALUE' | translate}}</th>
                        <th *ngIf="allowEdit && detailForm.get('Discounts').enabled" width="1%"></th>
                      </tr>
                    </thead>
                    <tbody formArrayName="Discounts">
                      <tr *ngFor="let item of detailForm.controls.Discounts.controls; let i=index" [formGroupName]="i">
                        <td>
                          <mat-form-field class="allwidth">
                            <input matInput formControlName="DiscountType">
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field class="allwidth">
                            <input format matInput formControlName="Percentage" class="text-right one"
                              (focusout)="calculateDetailValues()">
                            <i matSuffix class="one">%</i>
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field class="allwidth">
                            <input format matInput  formControlName="Amount" class="text-right one">
                          </mat-form-field>
                        </td>
                        <td class="text-right" *ngIf="allowEdit && detailForm.get('Discounts').enabled">
                          <button type="button" class="btn btn-sm" (click)="removeDiscount(i)">
                            <span title="{{'BUTTON.DELETE' | translate}}">
                              <i class="far fa-trash-alt color-danger backwhite"></i>
                            </span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel referências -->
        <div class="col-sm-12" *ngIf="showReferencesPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup9"
              (click)="collPnPopup9 = !collPnPopup9">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'REFERENCES' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup9, 'fa-caret-up': !collPnPopup9}"></i>
              </h5>
            </div>
            <div id="collPnPopup9" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <div class="col-md-12 col-sm-12" *ngIf="!formDisabled">
                  <button type="button" class="btn btn-primary no-margin-left" title="{{'LINE' | translate}}"
                    *ngIf="allowEdit" (click)="addOtherReference(true)">
                    <i class="fas fa-plus"></i>&nbsp;{{'ADD' | translate}}
                  </button>
                </div>
                <!-- <div *ngIf="detailForm.controls.OtherReferences.length >0" class="table-responsive col-md-12 col-sm-12"> -->
                <div class="table-responsive col-md-12 col-sm-12">
                  <div *ngIf="formErrorsOtherReferences.length>0"
                    class="validation-summary-errors text-danger col-md-6">
                    <ul>
                      <li *ngFor="let errorMessage of formErrorsOtherReferences; let i = index" [translate]
                        [translateParams]="formErrorsOtherReferencesParam[i]">{{errorMessage}}</li>
                    </ul>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th class="text-center">{{ 'TYPE' | translate}}</th>
                        <th class="text-center">{{ 'VALUE' | translate}}</th>
                        <th class="text-center">{{ 'DATE' | translate}}</th>
                        <th *ngIf="allowEdit"></th>
                      </tr>
                    </thead>
                    <tbody
                      *ngIf="detailForm.controls.OtherReferences && detailForm.controls.OtherReferences.length > 0; else bodyNoResultsOtherReferences"
                      formArrayName="OtherReferences">
                      <tr *ngFor="let item of detailForm.controls.OtherReferences.controls; let i=index"
                        [formGroupName]="i">
                        <td>
                          <!-- Tipo Descritivo -->
                          <mat-form-field class="allwidth" *ngIf="!showOthersReferencesTypes">
                            <input matInput formControlName="ReferenceType">
                          </mat-form-field>
                          <!-- Lista de Tipos -->
                          <mat-form-field class="full-width" *ngIf="showOthersReferencesTypes">
                            <mat-select formControlName="ReferenceType">
                              <mat-option></mat-option>
                              <mat-option *ngFor="let item of otherReferenceTypes" [value]="item.ItemCode">
                                {{item.ItemName}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field class="allwidth">
                            <input matInput formControlName='ReferenceValue'>
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field class="allwidth">
                            <input matInput formControlName="ReferenceDate" class="one date-picker">
                              <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                          </mat-form-field>
                        </td>
                        <td class="text-right" *ngIf="allowEdit">
                          <button type="button" class="btn btn-sm" (click)="removeOtherReference(i)">
                            <span title="{{'BUTTON.DELETE' | translate}}">
                              <i class="far fa-trash-alt color-danger backwhite"></i>
                            </span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <ng-template #bodyNoResultsOtherReferences>
                      <tbody>
                        <tr>
                          <td colspan="4" class="text-center">
                            {{ 'NO_RESULTS_WERE_FOUND' | translate}}
                          </td>
                        </tr>
                      </tbody>
                    </ng-template>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel fornecedor -->
        <div class="col-sm-12" *ngIf="showSupplierPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup10"
              (click)="collPnPopup10 = !collPnPopup10">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'PROVIDER' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup10, 'fa-caret-up': !collPnPopup10}"></i>
              </h5>
            </div>
            <div id="collPnPopup10" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <div class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'CODE' | translate}}</mat-label>
                    <input matInput (change)="checkSupplier()"
                      formControlName="SupplierIdentifier" class="one">
                      <i matSuffix class="glyphicon glyphicon-new-window" (click)="selectProvider()"></i>
                  </mat-form-field>
                </div>
                <div class="col-md-1 col-sm-12"></div>
                <div class="col-md-4 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'NAME' | translate}}</mat-label>
                    <input matInput formControlName="SupplierName">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel observações (notas) -->
        <div class="col-sm-12" *ngIf="showNotesPanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup11"
              (click)="collPnPopup11 = !collPnPopup11">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'OBSERVATIONS' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup11, 'fa-caret-up': !collPnPopup11}"></i>
              </h5>
            </div>
            <div id="collPnPopup11" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth">
                    <textarea matInput formControlName="NoteToShow" class="no-resize" rows="3"></textarea>
                  </mat-form-field>
                  <error [control]="detailForm.get('NoteToShow')"></error>
                </div>

                <!--Espaço -->
                <div *ngIf="detailForm.controls.OtherNotes.length>0" class="col-md-12 spacer-bottom-xs"></div>

                <!-- Lista de outras observações (outro tipo que não PortalObs) -->
                <div *ngIf="detailForm.controls.OtherNotes.length>0" class="table-responsive col-md-12 col-sm-12">
                  <div *ngIf="formErrorsNotes.length>0" class="validation-summary-errors text-danger col-md-6">
                    <ul>
                      <li *ngFor="let errorMessage of formErrorsNotes; let i = index" [translate]
                        [translateParams]="formErrorsNotesParam[i]">{{errorMessage}}</li>
                    </ul>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th width="20%" class="text-center">{{ 'TYPE' | translate}}</th>
                        <th width="80%" class="text-center">{{ 'VALUE' | translate}}</th>
                        <!-- <th *ngIf="!model.ID || (allowEdit && model.StateIsEditable)" width="10%"></th> -->
                      </tr>
                    </thead>
                    <tbody formArrayName="OtherNotes">
                      <tr *ngFor="let item of detailForm.controls.OtherNotes.controls; let i=index" [formGroupName]="i">
                        <td>
                          <mat-form-field class="allwidth">
                            <input matInput formControlName='NoteType' [disabled]="true">
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field class="allwidth">
                            <textarea matInput formControlName="NoteValue" class="no-resize" rows="1"
                              [disabled]="true"></textarea>
                          </mat-form-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel estado -->
        <div class="col-sm-12" *ngIf="detailForm.controls.ID.value && showStatePanel">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup12"
              (click)="collPnPopup12 = !collPnPopup12">
              <h5 class="panel-title">
                <i class="fas fa-tasks"></i>
                <strong>{{ 'STATE' | translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup12, 'fa-caret-up': !collPnPopup12}"></i>
              </h5>
            </div>
            <div id="collPnPopup12" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">
                <!-- Estado da linha -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'LINE_STATE' | translate}}</mat-label>
                    <input matInput formControlName="LineState">
                  </mat-form-field>
                  <span *ngIf="formErrors.LineState" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.LineState">{{ formErrors.LineState }}</span>
                </div>
                <!-- Quantidade a entregar -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'REVISED_QUANTITY' | translate}}</mat-label>
                    <input matInput formControlName="RevisedQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.RevisedQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.RevisedQuantity">{{ formErrors.RevisedQuantity }}</span>
                </div>
                <!-- Quantidade expedida -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'DESPATCHED_QUANTITY' | translate}}</mat-label>
                    <!--05/07/2022 -> Previamente o valor utilizado neste campo era 'SatisfiedQuantity' -->
                    <input matInput
                      formControlName="DespatchedQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.SatisfiedQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.SatisfiedQuantity">{{ formErrors.SatisfiedQuantity }}</span>
                </div>
                <!-- Quantidade entregue -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'SATISFIED_QUANTITY' | translate}}</mat-label>
                    <input matInput
                      formControlName="ReceivedQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.ReceivedQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ReceivedQuantity">{{ formErrors.ReceivedQuantity }}</span>
                </div>
                <!-- Quantidade recebida -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'RECEIVED_QUANTITY' | translate}}</mat-label>
                    <input matInput
                      formControlName="ReceivedQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.ReceivedQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ReceivedQuantity">{{ formErrors.ReceivedQuantity }}</span>
                </div>
                <!-- Quantidade faturada -->
                <div class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'INVOICE_QUANTITY' | translate}}</mat-label>
                    <input matInput
                      formControlName="InvoiceToQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.InvoiceToQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.InvoiceToQuantity">{{ formErrors.InvoiceToQuantity }}</span>
                </div>
                <!-- Quantidade devolvida -->
                <div *ngIf="showReturnedQuantity" class="col-md-2 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'RETURNED_QUANTITY' | translate}}</mat-label>
                    <input matInput
                      formControlName="ReturnedQuantity">
                  </mat-form-field>
                  <span *ngIf="formErrors.ReturnedQuantity" class="field-validation-valid text-danger" [translate]
                    [translateParams]="formErrorsParam.ReturnedQuantity">{{ formErrors.ReturnedQuantity }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right" *ngIf="detailForm.enabled">
      <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}"
        (click)="resetForm(); dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button *ngIf="allowEdit" type="button" class="btn btn-primary" title="{{'BUTTON.SAVE' | translate}}"
        (click)="save()">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
      </button>
    </div>

    <div class="full-width text-right" *ngIf="detailForm.disabled">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
        {{'CLOSE' | translate}}
      </button>
    </div>

  </div>
</div>